import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * allow: מערך של user_type שמותר להיכנס (לדוגמה [3] לסוחר)
 * redirectTo: לאן להפנות אם לא מחובר (לדוגמה "/" או "/signnprovider")
 */
export default function RequireRole({
  currentUser,
  allow = [],
  redirectTo = "/",
  children,
}) {
  const location = useLocation();
  const userType = currentUser?.user_type;

  // לא מחובר -> לוגין + שמירת יעד לחזרה
  if (!currentUser) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  // מחובר אבל לא הסוג הנכון -> שולחים לדשבורד שלו
  if (!allow.includes(userType)) {
    const fallback =
      userType === 1
        ? "/admin"
        : userType === 2
        ? "/dashboard-provider"
        : userType === 3
        ? "/dashboard-dealer"
        : redirectTo;

    return <Navigate to={fallback} replace />;
  }

  return children;
}
